__turbopack_context__.v({
  "TabLinks": "WAKAna_TabLinks",
  "TabLinks__Container": "WAKAna_TabLinks__Container",
  "TabLinks__Tab": "WAKAna_TabLinks__Tab",
  "TabLinks__Tab--Active": "WAKAna_TabLinks__Tab--Active",
  "TabLinks__TabWrapper": "WAKAna_TabLinks__TabWrapper",
  "TabLinks__TabWrapper--SpaceBetween": "WAKAna_TabLinks__TabWrapper--SpaceBetween",
});
